import React from 'react'
import type { IconName } from '../../../shared/webcomponents/helpers/icons'
import type { LOZENGE_COLORS } from '../../../shared/webcomponents/zaptic-lozenge'

export type Props = {
    icon: IconName
    label: string
    onClick: () => void
    lozenge?: {
        label: string
        color: typeof LOZENGE_COLORS
    }
}

export function FlexibleListAdd({ label, icon, onClick, lozenge }: Props) {
    return (
        <button className="AppCore__ui__FlexibleListAdd" onClick={onClick}>
            <zaptic-icon icon-name={icon} />
            {label}
            {lozenge && <zaptic-lozenge color={lozenge.color} label={lozenge.label} />}
        </button>
    )
}
